import * as React from 'react';
import Modal from 'antd/lib/modal';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { InquiryType } from 'src/Library/Constants';
import { Button, Icon, message } from 'src/Library/AntdLibComponents';
import withStyles from 'react-jss';
import Upload from 'antd/lib/upload';
import { uploadToS3, getS3Links } from 'src/api/invoice';
import { getFileExtension } from 'src/utils/utils';
import { tokens } from 'src/design-system';
import Asterisk from 'src/components/common/Asterisk';

const styles = (theme) => ({
  modal: {
    '& .ant-modal-body': {
      paddingBottom: '80px',
    },
  },
  additionalText: {
    marginTop: '14px',
    color: '#666666',
    fontSize: `${tokens.fontSize.small}px`,
    fontStyle: 'italic',
  },
});

interface IProps extends StylesProps<ReturnType<typeof styles>> {
  isVisible: boolean;
  handleCancel: () => void;
  handleSubmit: (bookingNote) => void;
  type: string;
}

interface StateProps {
  isBooking?: boolean;
  fileName?: string;
  isUploading?: boolean;
  fileUrl?: string;
}

const UploadTruckingDOModal = (props : IProps) => {
  const {
    isVisible,
    handleCancel,
    handleSubmit,
    classes,
    type,
  } = props;

  const [state, setState] = useGenericState<StateProps>({});

  const {
    isBooking,
    fileName,
    isUploading,
    fileUrl
  } = state;

  const title = (type === InquiryType.EXPORT ? 'Booking Note' : 'DO');

  const createBooking = async () => {
    setState({ isBooking: true });
    await handleSubmit({
      bookingNote: {
        url: fileUrl,
        name: fileName,
      },
    });
    setState({ isBooking: false });
  }

  const renderFooter = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <a style={{ color: tokens.colors.primary, fontSize: `${tokens.fontSize.h3}px` }}
          onClick={handleCancel}>Previous</a>
        <Button
          loading={isBooking}
          type="primary"
          style={{
            backgroundColor: tokens.colors.primary,
            border: tokens.colors.primary,
          }}
          disabled={!fileName || !fileUrl}
          onClick={createBooking}>
            Submit Booking
        </Button>
      </div>
    );
  }

  const s3LinkRequest = async ({ file }): Promise<void> => {
    setState({
      isUploading: true,
      fileName: file.name,
    });
    const extension = getFileExtension(file.name);
    const response = await getS3Links({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'Booking',
    });
    let fileUrl: string = '';
    if (response.isSuccess) {
      const upload = await uploadToS3(response.data.post, extension, file);
      if (upload.isSuccess) fileUrl = response.data.get;
    } else {
      message.error(response.errorMessage);
    }
    setState({
      fileUrl,
      isUploading: false,
    });
  };

  return (
    <Modal
      width={400}
      title={`Add ${title}`}
      visible={isVisible}
      onCancel={handleCancel}
      footer={renderFooter()}
      className={classes.modal}
    >
      <div>
        {title}<Asterisk />
        <Upload
          showUploadList={false}
          multiple={false}
          customRequest={file => s3LinkRequest(file)}
          disabled={isUploading}>
          <Button loading={isUploading} style={{ marginLeft: '16px' }}>
            <Icon type="upload" /> Upload
          </Button>
        </Upload>
        <div style={{ fontSize: `${tokens.fontSize.small}px`, marginTop: '12px' }}>
          {fileName}
          {fileName && <Icon type="close" style={{ color: 'red', marginLeft: '8px' }}
            onClick={() => setState({ fileName: '', fileUrl: '' })} />}
        </div>
        <div className={classes.additionalText}>
          {`Allow Trucker to pick up the container(s) by providing the
          ${type === InquiryType.EXPORT ? 'Booking Note' : 'DO Document'}.`}
        </div>
      </div>
    </Modal>
  );
};

export default withStyles(styles)(React.memo(UploadTruckingDOModal));
